/**
 * @generated SignedSource<<b74e6a9ab112afe15946c9f76c1c9281>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SubscriptionState = "POST_SUBSCRIBED" | "POST_TRIAL" | "SUBSCRIBED" | "TRIAL";
import { FragmentRefs } from "relay-runtime";
export type RecordingRowOutOfCreditsWarning_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly isSubscriptionActive: boolean;
      readonly subscriptionBillingCycleAnchor: string | null;
      readonly subscriptionState: SubscriptionState;
    };
    readonly primaryAdmin: {
      readonly fullName: string;
    } | null;
    readonly recordingCredits: {
      readonly includedAiMeetingCredits: number;
    };
  };
  readonly hasAdminAccess: boolean;
  readonly " $fragmentType": "RecordingRowOutOfCreditsWarning_viewer";
};
export type RecordingRowOutOfCreditsWarning_viewer$key = {
  readonly " $data"?: RecordingRowOutOfCreditsWarning_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecordingRowOutOfCreditsWarning_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecordingRowOutOfCreditsWarning_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAdminAccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "primaryAdmin",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AccountRecordingCredits",
          "kind": "LinkedField",
          "name": "recordingCredits",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includedAiMeetingCredits",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSubscriptionActive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionState",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subscriptionBillingCycleAnchor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ac8f04a78101b81284b4236c0c8db157";

export default node;
